/**
 * Calculadora de macros + recomendador de platos — Fuel Food
 *
 * Todo client-side. Los datos de los platos llegan serializados desde Liquid
 * (metafields custom.*), no se hace ninguna petición de red para obtenerlos.
 */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------- */
  /* i18n — mismo criterio que el resto de la tienda (ca / es / en / fr)      */
  /* ----------------------------------------------------------------------- */

  var I18N = {
    es: {
      sex: 'Sexo', male: 'Hombre', female: 'Mujer', age: 'Edad', years: 'años',
      weight: 'Peso', height: 'Altura', activity: 'Nivel de actividad',
      act1: 'Ligero (1-2 días/semana)', act2: 'Moderado (3-4 días/semana)',
      act3: 'Alto (5-7 días/semana)',
      goal: 'Objetivo', goalLose: 'Perder grasa', goalMaintain: 'Mantener peso',
      goalGain: 'Ganar músculo', goalPerf: 'Rendimiento / resistencia',
      meals: 'Comidas de Fuel Food al día', meals1: '1 comida', meals2: '2 comidas',
      excludeAllergens: 'Excluir alérgenos', calculate: 'Calcular mis macros', reset: 'Reiniciar',
      disclaimer: 'Estimación orientativa basada en la ecuación de Mifflin-St Jeor. No sustituye el consejo de un profesional de la nutrición o la medicina.',
      heading: 'Calcula tus macros',
      subheading: 'Introduce tus datos y te decimos cuánto necesitas al día y qué platos de esta semana encajan mejor.',
      yourTargets: 'Tus objetivos diarios',
      protein: 'Proteínas', carbs: 'Hidratos', fats: 'Grasas',
      bmr: 'Metabolismo basal', tdee: 'Gasto total diario',
      recommended: 'Tu plan para la semana',
      days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
      noDishes: 'Ahora mismo no hay platos disponibles con datos nutricionales completos. Vuelve a probarlo cuando se publique el menú de la semana.',
      noMatches: 'Ningún plato encaja con los filtros seleccionados. Prueba a quitar alguna exclusión de alérgenos.',
      viewDish: 'Ver plato', addToCart: 'Añadir al carrito', added: '✓ Añadido', adding: 'Añadiendo…',
      errAdd: 'No se pudo añadir. Abre el plato para comprarlo.',
      ofDaily: 'de tu día', invalid: 'Revisa los datos: introduce una edad, peso y altura válidos.',
      perDay: '/día',
      floorNote: 'Hemos ajustado tu objetivo al mínimo recomendable de {n} kcal. Un aporte inferior no es aconsejable sin supervisión profesional.',
      addAll: 'Añadir los {n} al carrito', addingAll: 'Añadiendo…',
      addedAll: '✓ {n} platos añadidos', errAddAll: 'No se pudieron añadir todos. Inténtalo de nuevo.',
      repeatTag: '×{n} esta semana', planReady: 'Plan generado: {n} platos para {d} días.',
      addedSome: '✓ Añadidos {n} de {m} (algún plato sin stock suficiente)',
      // Etiquetas de los 12 alérgenos que declara la tienda. Las claves son
      // las normalizadas (sin acentos, en minúscula) que produce allergenKey().
      allergens: {
        gluten: 'Gluten', lactosa: 'Lactosa', huevo: 'Huevo',
        'frutos secos': 'Frutos secos', cacahuete: 'Cacahuete', soja: 'Soja',
        sesamo: 'Sésamo', marisco: 'Marisco', pescado: 'Pescado',
        apio: 'Apio', mostaza: 'Mostaza', sulfitos: 'Sulfitos'
      }
    },
    ca: {
      sex: 'Sexe', male: 'Home', female: 'Dona', age: 'Edat', years: 'anys',
      weight: 'Pes', height: 'Alçada', activity: "Nivell d'activitat",
      act1: 'Lleuger (1-2 dies/setmana)', act2: 'Moderat (3-4 dies/setmana)',
      act3: 'Alt (5-7 dies/setmana)',
      goal: 'Objectiu', goalLose: 'Perdre greix', goalMaintain: 'Mantenir pes',
      goalGain: 'Guanyar múscul', goalPerf: 'Rendiment / resistència',
      meals: 'Àpats de Fuel Food al dia', meals1: '1 àpat', meals2: '2 àpats',
      excludeAllergens: 'Excloure al·lèrgens', calculate: 'Calcular els meus macros', reset: 'Reiniciar',
      disclaimer: "Estimació orientativa basada en l'equació de Mifflin-St Jeor. No substitueix el consell d'un professional de la nutrició o la medicina.",
      heading: 'Calcula els teus macros',
      subheading: "Introdueix les teves dades i et direm quant necessites al dia i quins plats d'aquesta setmana encaixen millor.",
      yourTargets: 'Els teus objectius diaris',
      protein: 'Proteïnes', carbs: 'Hidrats', fats: 'Greixos',
      bmr: 'Metabolisme basal', tdee: 'Despesa total diària',
      recommended: 'El teu pla per a la setmana',
      days: ['Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte', 'Diumenge'],
      noDishes: 'Ara mateix no hi ha plats disponibles amb dades nutricionals completes. Torna-ho a provar quan es publiqui el menú de la setmana.',
      noMatches: "Cap plat encaixa amb els filtres seleccionats. Prova de treure alguna exclusió d'al·lèrgens.",
      viewDish: 'Veure plat', addToCart: 'Afegir al carret', added: '✓ Afegit', adding: 'Afegint…',
      errAdd: 'No s\'ha pogut afegir. Obre el plat per comprar-lo.',
      ofDaily: 'del teu dia', invalid: 'Revisa les dades: introdueix una edat, pes i alçada vàlids.',
      perDay: '/dia',
      floorNote: 'Hem ajustat el teu objectiu al mínim recomanable de {n} kcal. Un aport inferior no és aconsellable sense supervisió professional.',
      addAll: 'Afegir els {n} al carret', addingAll: 'Afegint…',
      addedAll: '✓ {n} plats afegits', errAddAll: "No s'han pogut afegir tots. Torna-ho a provar.",
      repeatTag: '×{n} aquesta setmana', planReady: 'Pla generat: {n} plats per a {d} dies.',
      addedSome: '✓ Afegits {n} de {m} (algun plat sense prou estoc)',
      // Etiquetas de los 12 alérgenos que declara la tienda. Las claves son
      // las normalizadas (sin acentos, en minúscula) que produce allergenKey().
      allergens: {
        gluten: 'Gluten', lactosa: 'Lactosa', huevo: 'Ou',
        'frutos secos': 'Fruits secs', cacahuete: 'Cacauet', soja: 'Soja',
        sesamo: 'Sèsam', marisco: 'Marisc', pescado: 'Peix',
        apio: 'Api', mostaza: 'Mostassa', sulfitos: 'Sulfits'
      }
    },
    en: {
      sex: 'Sex', male: 'Male', female: 'Female', age: 'Age', years: 'years',
      weight: 'Weight', height: 'Height', activity: 'Activity level',
      act1: 'Light (1-2 days/week)', act2: 'Moderate (3-4 days/week)',
      act3: 'High (5-7 days/week)',
      goal: 'Goal', goalLose: 'Lose fat', goalMaintain: 'Maintain weight',
      goalGain: 'Build muscle', goalPerf: 'Performance / endurance',
      meals: 'Fuel Food meals per day', meals1: '1 meal', meals2: '2 meals',
      excludeAllergens: 'Exclude allergens', calculate: 'Calculate my macros', reset: 'Reset',
      disclaimer: 'Indicative estimate based on the Mifflin-St Jeor equation. It does not replace advice from a nutrition or medical professional.',
      heading: 'Calculate your macros',
      subheading: "Enter your details and we'll show you what you need each day and which of this week's dishes fit you best.",
      yourTargets: 'Your daily targets',
      protein: 'Protein', carbs: 'Carbs', fats: 'Fats',
      bmr: 'Basal metabolic rate', tdee: 'Total daily expenditure',
      recommended: 'Your plan for the week',
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      noDishes: 'There are currently no available dishes with complete nutritional data. Please check back when this week’s menu is published.',
      noMatches: 'No dish matches the selected filters. Try removing an allergen exclusion.',
      viewDish: 'View dish', addToCart: 'Add to cart', added: '✓ Added', adding: 'Adding…',
      errAdd: 'Could not add. Open the dish to buy it.',
      ofDaily: 'of your day', invalid: 'Check your data: enter a valid age, weight and height.',
      perDay: '/day',
      floorNote: 'We raised your target to the recommended minimum of {n} kcal. Going below that is not advisable without professional supervision.',
      addAll: 'Add all {n} to cart', addingAll: 'Adding…',
      addedAll: '✓ {n} dishes added', errAddAll: 'Could not add all. Please try again.',
      repeatTag: '×{n} this week', planReady: 'Plan ready: {n} dishes across {d} days.',
      addedSome: '✓ Added {n} of {m} (some dishes low on stock)',
      // Etiquetas de los 12 alérgenos que declara la tienda. Las claves son
      // las normalizadas (sin acentos, en minúscula) que produce allergenKey().
      allergens: {
        gluten: 'Gluten', lactosa: 'Lactose', huevo: 'Egg',
        'frutos secos': 'Tree nuts', cacahuete: 'Peanut', soja: 'Soy',
        sesamo: 'Sesame', marisco: 'Shellfish', pescado: 'Fish',
        apio: 'Celery', mostaza: 'Mustard', sulfitos: 'Sulphites'
      }
    },
    fr: {
      sex: 'Sexe', male: 'Homme', female: 'Femme', age: 'Âge', years: 'ans',
      weight: 'Poids', height: 'Taille', activity: "Niveau d'activité",
      act1: 'Léger (1-2 jours/semaine)', act2: 'Modéré (3-4 jours/semaine)',
      act3: 'Élevé (5-7 jours/semaine)',
      goal: 'Objectif', goalLose: 'Perdre de la graisse', goalMaintain: 'Maintenir le poids',
      goalGain: 'Prendre du muscle', goalPerf: 'Performance / endurance',
      meals: 'Repas Fuel Food par jour', meals1: '1 repas', meals2: '2 repas',
      excludeAllergens: 'Exclure les allergènes', calculate: 'Calculer mes macros', reset: 'Réinitialiser',
      disclaimer: "Estimation indicative basée sur l'équation de Mifflin-St Jeor. Ne remplace pas l'avis d'un professionnel de la nutrition ou de la médecine.",
      heading: 'Calculez vos macros',
      subheading: "Saisissez vos données et nous vous dirons ce dont vous avez besoin chaque jour et quels plats de cette semaine vous conviennent le mieux.",
      yourTargets: 'Vos objectifs quotidiens',
      protein: 'Protéines', carbs: 'Glucides', fats: 'Lipides',
      bmr: 'Métabolisme de base', tdee: 'Dépense totale quotidienne',
      recommended: 'Votre plan pour la semaine',
      days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
      noDishes: 'Il n’y a actuellement aucun plat disponible avec des données nutritionnelles complètes. Revenez lorsque le menu de la semaine sera publié.',
      noMatches: 'Aucun plat ne correspond aux filtres sélectionnés. Essayez de retirer une exclusion d’allergène.',
      viewDish: 'Voir le plat', addToCart: 'Ajouter au panier', added: '✓ Ajouté', adding: 'Ajout…',
      errAdd: 'Impossible d’ajouter. Ouvrez le plat pour l’acheter.',
      ofDaily: 'de votre journée', invalid: 'Vérifiez vos données : saisissez un âge, un poids et une taille valides.',
      perDay: '/jour',
      floorNote: 'Nous avons ajusté votre objectif au minimum recommandé de {n} kcal. En dessous, un suivi professionnel est nécessaire.',
      addAll: 'Ajouter les {n} au panier', addingAll: 'Ajout…',
      addedAll: '✓ {n} plats ajoutés', errAddAll: 'Impossible de tout ajouter. Réessayez.',
      repeatTag: '×{n} cette semaine', planReady: 'Plan généré : {n} plats pour {d} jours.',
      addedSome: '✓ {n} sur {m} ajoutés (stock insuffisant pour certains plats)',
      // Etiquetas de los 12 alérgenos que declara la tienda. Las claves son
      // las normalizadas (sin acentos, en minúscula) que produce allergenKey().
      allergens: {
        gluten: 'Gluten', lactosa: 'Lactose', huevo: 'Œuf',
        'frutos secos': 'Fruits à coque', cacahuete: 'Arachide', soja: 'Soja',
        sesamo: 'Sésame', marisco: 'Fruits de mer', pescado: 'Poisson',
        apio: 'Céleri', mostaza: 'Moutarde', sulfitos: 'Sulfites'
      }
    }
  };

  function detectLang() {
    var code = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
    return I18N[code] ? code : 'es';
  }

  /* ----------------------------------------------------------------------- */
  /* Utilidades                                                               */
  /* ----------------------------------------------------------------------- */

  /**
   * Los metafields numéricos pueden llegar como número o como texto con coma
   * decimal ("25,0"). Normalizamos ambos casos.
   */
  function toNumber(raw) {
    if (typeof raw === 'number') return isFinite(raw) ? raw : null;
    if (typeof raw !== 'string') return null;
    var cleaned = raw.replace(/\s/g, '').replace(',', '.').replace(/[^0-9.\-]/g, '');
    var n = parseFloat(cleaned);
    return isFinite(n) ? n : null;
  }

  /**
   * `alergenos` puede ser una lista (metafield de tipo list) o un texto libre
   * separado por "•", "," o ";". Devolvemos siempre un array de strings.
   */
  function toList(raw) {
    if (Array.isArray(raw)) return raw.map(String).map(trim).filter(Boolean);
    if (typeof raw === 'string') return raw.split(/[•,;|]/).map(trim).filter(Boolean);
    return [];
  }

  function trim(s) { return String(s).trim(); }

  /**
   * Clave normalizada de un alérgeno: minúsculas, sin acentos y sin espacios
   * de más. Es lo que se compara.
   *
   * Importa de verdad: los metafields se rellenan a mano cada semana, así que
   * "Gluten", "gluten" y "Glúten" son el mismo alérgeno. Comparando el texto
   * tal cual, un cliente que excluye "Gluten" podría recibir un plato marcado
   * "gluten" — en un filtro de alérgenos eso es un problema de seguridad, no
   * de estética.
   */
  function allergenKey(value) {
    return String(value == null ? '' : value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Los 12 alérgenos que declara la tienda. Esta lista es la que dibuja los
  // chips del filtro: se muestran todos siempre, contenga o no el menú de la
  // semana cada uno de ellos. Si un plato declara algo fuera de la lista se
  // añade igualmente y se avisa por consola (posible errata en el metafield):
  // nunca se oculta un alérgeno desconocido.
  var ALLERGEN_CANON = [
    'gluten', 'lactosa', 'huevo', 'frutos secos', 'cacahuete', 'soja',
    'sesamo', 'marisco', 'pescado', 'apio', 'mostaza', 'sulfitos'
  ];

  /**
   * Sinónimos de cada alérgeno.
   *
   * Hace falta porque la capa de traducción de la tienda traduce el metafield
   * `alergenos`, y lo hace de forma desigual: en /en conviven platos marcados
   * "Lactose" con otros marcados "Lactosa", y "Marisco" sale como "Seafood".
   * Sin esto son alérgenos distintos para el filtro, así que quien excluyera
   * "Lactose" seguiría recibiendo los platos marcados "Lactosa" — un fallo de
   * seguridad, no de estética.
   *
   * A esta tabla se le suman automáticamente las etiquetas de los cuatro
   * diccionarios de I18N (ver ALIAS_INDEX), así que aquí solo hace falta lo
   * que el traductor escribe distinto a nosotros y las variantes habituales
   * (plurales, "leche" por "lactosa", "crustáceos" por "marisco"…).
   */
  var ALLERGEN_ALIASES = {
    gluten: ['trigo', 'wheat', 'ble', 'blat', 'froment', 'cereales con gluten',
             'cereals amb gluten', 'cereals containing gluten', 'cereales con gluten'],
    lactosa: ['leche', 'lacteos', 'llet', 'lactics', 'lactis', 'milk', 'dairy',
              'lait', 'produits laitiers', 'lactosa/leche'],
    huevo: ['huevos', 'egg', 'eggs', 'ou', 'ous', 'oeuf', 'oeufs', 'œuf', 'œufs'],
    'frutos secos': ['frutos de cascara', 'fruta de cascara', 'fruits secs',
                     'tree nuts', 'nuts', 'nuts and dried fruits', 'fruits a coque',
                     'fruits à coque'],
    cacahuete: ['cacahuetes', 'cacauet', 'cacauets', 'peanut', 'peanuts',
                'arachide', 'arachides', 'mani'],
    soja: ['soia', 'soy', 'soya', 'soybean', 'soybeans'],
    sesamo: ['sesame', 'sesam', 'ajonjoli', 'sesame seeds', 'graines de sesame'],
    marisco: ['mariscos', 'marisc', 'seafood', 'shellfish', 'crustaceos',
              'crustacis', 'crustaceans', 'crustaces', 'fruits de mer',
              'molusco', 'moluscos', 'mollusques', 'molluscs', 'mollusks'],
    pescado: ['pescados', 'peix', 'peixos', 'fish', 'poisson', 'poissons'],
    apio: ['api', 'celery', 'celeri', 'celeri-rave'],
    mostaza: ['mostassa', 'mustard', 'moutarde'],
    sulfitos: ['sulfits', 'sulphites', 'sulfites', 'sulfur dioxide',
               'dioxido de azufre', 'anhidrido sulfuroso', 'so2']
  };

  /**
   * Índice sinónimo normalizado -> clave canónica. Se construye una vez, a
   * partir de ALLERGEN_ALIASES y de las etiquetas de los cuatro idiomas, así
   * que basta con traducir un alérgeno en I18N para que su nombre también
   * valga como sinónimo.
   */
  var ALIAS_INDEX = (function () {
    var index = {};
    ALLERGEN_CANON.forEach(function (key) {
      index[key] = key;
      (ALLERGEN_ALIASES[key] || []).forEach(function (alias) {
        index[allergenKey(alias)] = key;
      });
    });
    Object.keys(I18N).forEach(function (code) {
      var labels = I18N[code].allergens || {};
      Object.keys(labels).forEach(function (key) {
        if (index[key]) index[allergenKey(labels[key])] = key;
      });
    });
    return index;
  })();

  /**
   * Reduce una etiqueta de alérgeno a su clave canónica. Si no la reconocemos
   * devolvemos la clave normalizada tal cual: preferimos un chip de más a
   * perder un alérgeno que un plato sí declara.
   */
  function canonAllergen(value) {
    var key = allergenKey(value);
    return ALIAS_INDEX[key] || key;
  }

  function normalizeCat(raw) {
    return String(raw == null ? '' : raw).toLowerCase().trim().replace(/[\s_-]+/g, ' ');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function clamp(n, lo, hi) { return Math.min(hi, Math.max(lo, n)); }

  /* ----------------------------------------------------------------------- */
  /* Cálculo de necesidades — Mifflin-St Jeor                                 */
  /* ----------------------------------------------------------------------- */

  /**
   * Perfiles por objetivo:
   *   kcalFactor   — ajuste sobre el gasto total diario
   *   proteinPerKg — gramos de proteína por kg de peso corporal
   *   fatPct       — porcentaje de las calorías totales que aporta la grasa
   *                  (se expresa como % y no como g/kg para que la grasa se
   *                  mantenga siempre en el rango saludable del 20-35%)
   *   cat          — categoría nutricional del catálogo que mejor encaja
   */
  var GOALS = {
    lose:        { kcalFactor: 0.80, proteinPerKg: 2.0, fatPct: 0.30, cat: 'low kcal' },
    maintain:    { kcalFactor: 1.00, proteinPerKg: 1.6, fatPct: 0.28, cat: 'balance' },
    gain:        { kcalFactor: 1.12, proteinPerKg: 2.0, fatPct: 0.25, cat: 'recovery' },
    performance: { kcalFactor: 1.05, proteinPerKg: 1.7, fatPct: 0.22, cat: 'endurance' }
  };

  // Suelo calórico de seguridad. Por debajo de estos valores no es responsable
  // dar una pauta sin supervisión profesional, así que la recortamos y avisamos.
  var MIN_KCAL = { female: 1200, male: 1500 };

  // Techo de proteína como fracción de las calorías totales: evita cifras
  // absurdas al aplicar g/kg sobre pesos altos con mucha masa grasa.
  var MAX_PROTEIN_SHARE = 0.40;

  /**
   * La necesidad de proteína también sube con la carga de entrenamiento, no
   * solo con el peso corporal: las recomendaciones deportivas van de ~1.2 g/kg
   * en personas poco activas a ~2.2 g/kg en carga alta. Sin este factor, la
   * proteína quedaba clavada al cambiar de nivel de actividad y solo se movían
   * grasas e hidratos (que absorben las calorías extra).
   */
  function proteinActivityFactor(activity) {
    if (activity <= 1.45) return 0.9; // ligero
    if (activity >= 1.7) return 1.1; // alto
    return 1.0; // moderado
  }

  function computeTargets(input) {
    var w = input.weight, h = input.height, a = input.age;

    var bmr = input.sex === 'female'
      ? 10 * w + 6.25 * h - 5 * a - 161
      : 10 * w + 6.25 * h - 5 * a + 5;

    var tdee = bmr * input.activity;
    var goal = GOALS[input.goal] || GOALS.maintain;
    var kcal = tdee * goal.kcalFactor;

    var floor = MIN_KCAL[input.sex] || MIN_KCAL.female;
    var floored = kcal < floor;
    if (floored) kcal = floor;

    var proteinPerKg = goal.proteinPerKg * proteinActivityFactor(input.activity);
    var protein = Math.min(proteinPerKg * w, (kcal * MAX_PROTEIN_SHARE) / 4);
    var fat = Math.max((kcal * goal.fatPct) / 9, 0.6 * w);

    // Los hidratos absorben el resto de calorías. Si el reparto no deja hueco,
    // recortamos grasa (hasta un mínimo fisiológico de 0.5 g/kg) antes de
    // tocar la proteína, que es el macro que más interesa preservar.
    var carbs = (kcal - protein * 4 - fat * 9) / 4;
    if (carbs < 0) {
      var minFat = 0.5 * w;
      fat = Math.max(minFat, fat + (carbs * 4) / 9);
      carbs = Math.max(0, (kcal - protein * 4 - fat * 9) / 4);
    }

    return {
      bmr: Math.round(bmr),
      tdee: Math.round(tdee),
      kcal: Math.round(kcal),
      protein: Math.round(protein),
      carbs: Math.round(carbs),
      fat: Math.round(fat),
      cat: goal.cat,
      floored: floored
    };
  }

  /* ----------------------------------------------------------------------- */
  /* Recomendador                                                             */
  /* ----------------------------------------------------------------------- */

  // Pesos del error por macro. Las calorías y la proteína mandan; la grasa es
  // la que más varía entre platos equivalentes, así que pesa menos.
  var W = { kcal: 1.0, protein: 1.0, carbs: 0.6, fat: 0.4 };
  var CATEGORY_BONUS = 0.75; // multiplicador del error si el plato es de la categoría del objetivo

  function scoreDish(dish, perMeal, goalCat) {
    function rel(actual, target) {
      if (!target) return 0;
      return Math.abs(actual - target) / target;
    }

    var err =
      W.kcal * rel(dish.kcal, perMeal.kcal) +
      W.protein * rel(dish.prot, perMeal.protein) +
      W.carbs * rel(dish.carb, perMeal.carbs) +
      W.fat * rel(dish.fat, perMeal.fat);

    err /= (W.kcal + W.protein + W.carbs + W.fat);

    if (goalCat && dish.catNorm === goalCat) err *= CATEGORY_BONUS;

    // Curva calibrada para que un buen encaje real (err ≈ 0.2-0.3) lea 70-80%
    // sin dejar de ordenar igual: err 0 → 100, 0.3 → 70, 0.6 → 49, 1.0 → 30.
    return {
      err: err,
      match: clamp(Math.round(100 * Math.exp(-err * 1.2)), 1, 99)
    };
  }

  /**
   * Construye el plan semanal: `days` días × `meals` platos por día.
   *
   * - Se seleccionan los `days × meals` platos con mejor encaje. Solo se
   *   repite un plato si el catálogo filtrado es más pequeño que el plan
   *   (p. ej. 15 huecos con 12 platos → los 3 mejores repiten una vez).
   * - Se reparten de mayor a menor kcal, cada uno al día menos cargado con
   *   hueco libre, evitando repetir plato dentro del mismo día si hay
   *   alternativa. Así todos los días quedan parejos en calorías.
   */
  function buildWeekPlan(ranked, days, meals) {
    var plan = [];
    for (var i = 0; i < days; i++) plan.push({ items: [], kcal: 0 });
    if (!ranked.length) return plan;

    var needed = days * meals;
    var selection = [];
    for (var j = 0; j < needed; j++) selection.push(ranked[j % ranked.length]);

    selection.sort(function (a, b) { return b.kcal - a.kcal; });
    selection.forEach(function (dish) {
      var open = plan.filter(function (day) { return day.items.length < meals; });
      var fresh = open.filter(function (day) {
        return !day.items.some(function (it) { return it.id === dish.id; });
      });
      var pool = fresh.length ? fresh : open;
      var target = pool[0];
      pool.forEach(function (day) { if (day.kcal < target.kcal) target = day; });
      target.items.push(dish);
      target.kcal += dish.kcal;
    });

    plan.forEach(function (day) {
      day.items.sort(function (a, b) { return a.err - b.err; });
    });
    return plan;
  }

  /* ----------------------------------------------------------------------- */
  /* Renderizado                                                              */
  /* ----------------------------------------------------------------------- */

  function legendItem(cls, label, grams) {
    return '<span class="macro-calc__legend-item">' +
      '<i class="macro-calc__dot macro-calc__dot--' + cls + '" aria-hidden="true"></i>' +
      escapeHtml(label) + ' <b>' + grams + ' g</b></span>';
  }

  function renderTargets(t, T) {
    // Reparto calórico real de los objetivos, para la barra de macros.
    var total = t.protein * 4 + t.carbs * 4 + t.fat * 9;
    var pP = total ? Math.round((t.protein * 4 / total) * 100) : 0;
    var pC = total ? Math.round((t.carbs * 4 / total) * 100) : 0;
    var pF = Math.max(0, 100 - pP - pC);
    var barLabel = T.protein + ' ' + pP + '% · ' + T.carbs + ' ' + pC + '% · ' + T.fats + ' ' + pF + '%';

    return '' +
      '<div class="macro-calc__summary">' +
        '<div class="macro-calc__summary-head">' +
          '<h3>' + escapeHtml(T.yourTargets) + '</h3>' +
          '<p class="macro-calc__meta">' +
            escapeHtml(T.bmr) + ' <strong>' + t.bmr + '</strong> · ' +
            escapeHtml(T.tdee) + ' <strong>' + t.tdee + '</strong> kcal' +
          '</p>' +
        '</div>' +
        '<div class="macro-calc__hero">' +
          '<span class="macro-calc__hero-num">' + t.kcal + '</span>' +
          '<span class="macro-calc__hero-unit">kcal' + escapeHtml(T.perDay) + '</span>' +
        '</div>' +
        '<div class="macro-calc__bar" role="img" aria-label="' + escapeHtml(barLabel) + '">' +
          '<span class="macro-calc__bar-seg macro-calc__bar-seg--p" style="width:' + pP + '%"></span>' +
          '<span class="macro-calc__bar-seg macro-calc__bar-seg--c" style="width:' + pC + '%"></span>' +
          '<span class="macro-calc__bar-seg macro-calc__bar-seg--f" style="width:' + pF + '%"></span>' +
        '</div>' +
        '<div class="macro-calc__legend">' +
          legendItem('p', T.protein, t.protein) +
          legendItem('c', T.carbs, t.carbs) +
          legendItem('f', T.fats, t.fat) +
        '</div>' +
        (t.floored
          ? '<p class="macro-calc__notice">' + escapeHtml(T.floorNote.replace('{n}', t.kcal)) + '</p>'
          : '') +
      '</div>';
  }

  function renderCard(dish, targets, T, showPrice, planCount) {
    var pctOfDay = targets.kcal ? Math.round((dish.kcal / targets.kcal) * 100) : 0;
    var img = dish.img
      ? '<img src="' + escapeHtml(dish.img) + '" alt="" loading="lazy" width="500" height="500">'
      : '<div class="macro-calc__card-noimg" aria-hidden="true"></div>';

    // Iniciales localizadas de cada macro (P/H/G en es, P/C/F en en, …).
    var iP = T.protein.charAt(0), iC = T.carbs.charAt(0), iF = T.fats.charAt(0);

    var allergens = dish.allergenList.length
      ? '<p class="macro-calc__allergen-note">' + escapeHtml(dish.allergenList.join(' · ')) + '</p>'
      : '';

    return '' +
      '<article class="macro-calc__card">' +
        '<a class="macro-calc__card-media" href="' + escapeHtml(dish.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="macro-calc__card-body">' +
          '<p class="macro-calc__overline">' +
            '<span>' + escapeHtml(dish.cat || '') +
              (planCount > 1
                ? (dish.cat ? ' · ' : '') + escapeHtml(T.repeatTag.replace('{n}', planCount))
                : '') +
            '</span>' +
            (dish.serving ? '<span>' + Math.round(dish.serving) + ' g</span>' : '') +
          '</p>' +
          // h5: los días del plan son h4, los platos cuelgan de su día.
          '<h5 class="macro-calc__card-title">' +
            '<a href="' + escapeHtml(dish.url) + '">' + escapeHtml(dish.title) + '</a>' +
          '</h5>' +
          '<p class="macro-calc__macroline">' +
            '<b>' + Math.round(dish.kcal) + ' kcal</b>' +
            '<span><i class="macro-calc__dot macro-calc__dot--p" aria-hidden="true"></i>' + Math.round(dish.prot) + iP + '</span>' +
            '<span><i class="macro-calc__dot macro-calc__dot--c" aria-hidden="true"></i>' + Math.round(dish.carb) + iC + '</span>' +
            '<span><i class="macro-calc__dot macro-calc__dot--f" aria-hidden="true"></i>' + Math.round(dish.fat) + iF + '</span>' +
          '</p>' +
          '<div class="macro-calc__dayrow">' +
            '<span class="macro-calc__daybar" aria-hidden="true"><span style="width:' + clamp(pctOfDay, 0, 100) + '%"></span></span>' +
            '<span class="macro-calc__share">' + pctOfDay + '% ' + escapeHtml(T.ofDaily) + '</span>' +
          '</div>' +
          allergens +
          '<div class="macro-calc__card-actions">' +
            (showPrice && dish.priceText
              ? '<span class="macro-calc__price">' + escapeHtml(dish.priceText) + '</span>' : '') +
            (dish.vid
              ? '<button type="button" class="macro-calc__add" data-add="' + dish.vid + '">' + escapeHtml(T.addToCart) + '</button>'
              : '<a class="macro-calc__add" href="' + escapeHtml(dish.url) + '">' + escapeHtml(T.viewDish) + '</a>') +
          '</div>' +
        '</div>' +
      '</article>';
  }

  /* ----------------------------------------------------------------------- */
  /* Añadir al carrito                                                        */
  /* ----------------------------------------------------------------------- */

  function cartRoute(endpoint) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + endpoint;
  }

  function cartUrl() {
    return cartRoute('cart/add.js');
  }

  /* ----------------------------------------------------------------------- */
  /* Atribución                                                               */
  /* ----------------------------------------------------------------------- */

  /**
   * Marca el carrito con un atributo para que en el admin de Shopify se vea
   * qué pedidos pasaron por la calculadora. El atributo viaja del carrito al
   * pedido, aparece en su ficha y sale en el export CSV de pedidos.
   *
   * No se guarda ningún dato personal (ni peso, ni edad, ni objetivo): solo
   * el hecho de haber usado la herramienta.
   *
   * Es telemetría: si falla, se ignora en silencio. Nunca debe interrumpir
   * una compra.
   */
  var MARK_KEY = 'Calculadora';
  var MARK_USED = 'Usada';
  var MARK_ADDED = 'Plan añadido al carrito';
  var MARK_RANK = { 'Usada': 1, 'Plan añadido al carrito': 2 };
  var currentMark = null;

  function markCart(value) {
    // Solo se sube de nivel: si ya añadió el plan, recalcular no lo degrada.
    if (currentMark && MARK_RANK[currentMark] >= MARK_RANK[value]) return;
    var previous = currentMark;
    currentMark = value;

    var body = { attributes: {} };
    body.attributes[MARK_KEY] = value;

    fetch(cartRoute('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update ' + r.status);
      })
      .catch(function (err) {
        currentMark = previous; // permite reintentarlo más adelante
        console.warn('[macro-calculator] no se pudo marcar el carrito:', err);
      });
  }

  /** Una sola llamada a /cart/add.js: admite 1 o N líneas de golpe. */
  function postToCart(items) {
    return fetch(cartUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          throw new Error('cart/add ' + r.status + (body.description ? ': ' + body.description : ''));
        });
      }
      // Los temas escuchan distintos eventos; emitimos los más habituales para
      // que la cabecera/cajón de carrito se refresque si sabe hacerlo.
      ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
      return r.json();
    });
  }

  /**
   * Añadir-todo tolerante a fallos de stock. El alta múltiple de
   * /cart/add.js es atómica: si UNA línea pide más unidades de las
   * disponibles (p. ej. un plato repetido con quantity 2 y solo 1 en
   * stock), Shopify devuelve 422 y no añade NINGUNA. Por eso: primero el
   * lote entero (camino rápido) y, si falla, línea a línea rebajando a 1
   * unidad las repetidas que no quepan, para salvar todo lo que sí hay.
   */
  function runAddAllAction(button, items, T) {
    if (button.disabled) return;
    var original = button.dataset.mcLabel || button.textContent;
    button.dataset.mcLabel = original;
    var total = items.reduce(function (s, it) { return s + it.quantity; }, 0);
    button.disabled = true;
    button.textContent = T.addingAll;

    function finish(added) {
      if (added) markCart(MARK_ADDED);
      if (!added) {
        button.disabled = false;
        button.textContent = T.errAddAll;
        setTimeout(function () { button.textContent = original; }, 3000);
        return;
      }
      button.textContent = added === total
        ? T.addedAll.replace('{n}', added)
        : T.addedSome.replace('{n}', added).replace('{m}', total);
      button.classList.add('is-added');
      setTimeout(function () {
        button.disabled = false;
        button.textContent = original;
        button.classList.remove('is-added');
      }, 3500);
    }

    postToCart(items)
      .then(function () { finish(total); })
      .catch(function (err) {
        console.warn('[macro-calculator] lote rechazado, reintento línea a línea:', err);
        var added = 0;
        var chain = Promise.resolve();
        items.forEach(function (it) {
          chain = chain.then(function () {
            return postToCart([it])
              .then(function () { added += it.quantity; })
              .catch(function () {
                if (it.quantity > 1) {
                  return postToCart([{ id: it.id, quantity: 1 }])
                    .then(function () { added += 1; })
                    .catch(function () {});
                }
              });
          });
        });
        chain.then(function () { finish(added); });
      });
  }

  /**
   * Gestiona el ciclo pulsar → cargando → éxito/error → volver al estado
   * inicial de cualquiera de los dos botones de compra.
   */
  function runCartAction(button, items, labels) {
    if (button.disabled) return;
    var original = button.dataset.mcLabel || button.textContent;
    button.dataset.mcLabel = original;
    button.disabled = true;
    button.textContent = labels.loading;

    postToCart(items)
      .then(function () {
        markCart(MARK_ADDED);
        button.textContent = labels.done;
        button.classList.add('is-added');
        setTimeout(function () {
          button.disabled = false;
          button.textContent = original;
          button.classList.remove('is-added');
        }, 2500);
      })
      .catch(function (err) {
        console.warn('[macro-calculator]', err);
        button.disabled = false;
        button.textContent = labels.error;
        setTimeout(function () { button.textContent = original; }, 3000);
      });
  }

  /* ----------------------------------------------------------------------- */
  /* Inicialización                                                           */
  /* ----------------------------------------------------------------------- */

  function init(root) {
    if (root.dataset.mcReady === 'true') return;
    root.dataset.mcReady = 'true';

    var lang = detectLang();
    var T = I18N[lang];

    // Traducimos las etiquetas estáticas del formulario.
    root.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      if (T[key]) el.textContent = T[key];
    });

    var scope = root.closest('.section') || root.parentNode;
    var dataEl = scope.querySelector('[data-macro-dishes]');
    if (!dataEl) {
      console.error('[macro-calculator] Falta el bloque de datos [data-macro-dishes].');
      return;
    }
    var raw = [];
    try {
      raw = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[macro-calculator] No se pudo leer el JSON de platos:', e);
      return;
    }

    var dishes = raw.map(function (d) {
      var kcal = toNumber(d.kcal), prot = toNumber(d.prot),
          carb = toNumber(d.carb), fat = toNumber(d.fat);
      if (kcal === null || prot === null || carb === null || fat === null) return null;

      // Aviso de calidad de dato: las kcal declaradas y las que implican los
      // macros no siempre cuadran en el catálogo. Usamos la declarada (es el
      // dato oficial al cliente) pero dejamos traza cuando el desfase es grande.
      var implied = prot * 4 + carb * 4 + fat * 9;
      if (implied > 0 && Math.abs(kcal - implied) / implied > 0.15) {
        console.warn(
          '[macro-calculator] Desfase kcal >15% en "' + d.title + '": declaradas ' +
          kcal + ' kcal vs ' + Math.round(implied) + ' kcal implícitas por los macros.'
        );
      }

      // Reducimos cada alérgeno a su clave canónica (así "Lactose" y "Lactosa"
      // son el mismo) y lo mostramos en el idioma de la página, no en el que
      // haya dejado el traductor en el metafield.
      var rawAllergens = toList(d.allergens);
      var keys = rawAllergens.map(canonAllergen);

      return {
        id: d.id, vid: d.vid, title: d.title, url: d.url, img: d.img,
        priceText: d.priceText,
        cat: d.cat || '', catNorm: normalizeCat(d.cat),
        kcal: kcal, prot: prot, carb: carb, fat: fat,
        serving: toNumber(d.serving),
        allergenList: keys.map(function (key, i) {
          return (T.allergens && T.allergens[key]) || rawAllergens[i];
        }),
        allergenKeys: keys
      };
    }).filter(Boolean);

    var form = root.querySelector('[data-macro-form]');
    var resultsEl = root.querySelector('[data-results]');
    var errorEl = root.querySelector('[data-error]');
    var statusEl = root.querySelector('[data-status]');
    var allergenBox = root.querySelector('[data-allergen-box]');
    var allergenList = root.querySelector('[data-allergen-list]');

    if (!dishes.length) {
      resultsEl.hidden = false;
      resultsEl.innerHTML = '<p class="macro-calc__empty">' + escapeHtml(T.noDishes) + '</p>';
      return;
    }

    // Filtro de alérgenos: siempre los 12 de la lista canónica, contenga o no
    // el menú de esta semana cada uno de ellos. Si se dibujaran solo los
    // presentes, el filtro cambiaría de forma cada semana y quien es alérgico
    // tendría que deducir de una ausencia que su alérgeno está contemplado.
    // Marcar uno que no aparece en ningún plato simplemente no descarta nada.
    var allergenLabels = T.allergens || {};
    var seenKeys = {};
    var allAllergens = ALLERGEN_CANON.map(function (key) {
      seenKeys[key] = true;
      return { key: key, label: allergenLabels[key] || key };
    });

    // Un alérgeno declarado en un plato pero ausente de la lista canónica se
    // añade al final con su texto tal cual: preferimos un chip de más a que un
    // cliente no pueda excluir algo que sí está en el plato.
    dishes.forEach(function (d) {
      d.allergenKeys.forEach(function (key, i) {
        if (!key || seenKeys[key]) return;
        seenKeys[key] = true;
        allAllergens.push({ key: key, label: d.allergenList[i] });
        console.warn(
          '[macro-calculator] Alérgeno no reconocido: "' + d.allergenList[i] + '". Se ' +
          'muestra igualmente, pero revisa si es una errata en el metafield del ' +
          'producto o un sinónimo que falta en ALLERGEN_ALIASES.'
        );
      });
    });
    allAllergens.sort(function (a, b) { return a.label.localeCompare(b.label, lang); });

    if (allAllergens.length) {
      allergenBox.hidden = false;
      allergenList.innerHTML = allAllergens.map(function (a) {
        return '<label class="macro-calc__chip">' +
          '<input type="checkbox" name="allergen" value="' + escapeHtml(a.key) + '">' +
          '<span>' + escapeHtml(a.label) + '</span></label>';
      }).join('');
    }

    var weekDays = clamp(parseInt(root.dataset.weekDays, 10) || 5, 1, 7);
    var showPrice = root.dataset.showPrice === 'true';
    var mealShare = (parseInt(root.dataset.mealShare, 10) || 30) / 100;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var fd = new FormData(form);
      var input = {
        sex: fd.get('sex'),
        age: toNumber(fd.get('age')),
        weight: toNumber(fd.get('weight')),
        height: toNumber(fd.get('height')),
        activity: toNumber(fd.get('activity')),
        goal: fd.get('goal')
      };

      var valid = input.age >= 15 && input.age <= 100 &&
                  input.weight >= 35 && input.weight <= 250 &&
                  input.height >= 120 && input.height <= 230;

      if (!valid) {
        errorEl.hidden = false;
        errorEl.textContent = T.invalid;
        resultsEl.hidden = true;
        return;
      }
      errorEl.hidden = true;

      var targets = computeTargets(input);

      // El nº de comidas Fuel Food modula el peso de cada comida: con 1 comida
      // al día esa comida puede ser algo mayor. Máximo 2 comidas/día.
      var meals = clamp(parseInt(fd.get('meals'), 10) || 2, 1, 2);
      var share = clamp(mealShare + (2 - meals) * 0.03, 0.2, 0.45);
      var perMeal = {
        kcal: Math.round(targets.kcal * share),
        protein: Math.round(targets.protein * share),
        carbs: Math.round(targets.carbs * share),
        fat: Math.round(targets.fat * share)
      };
      var excluded = fd.getAll('allergen');
      var pool = dishes.filter(function (d) {
        return !d.allergenKeys.some(function (k) { return excluded.indexOf(k) !== -1; });
      });

      var ranked = pool.map(function (d) {
        var s = scoreDish(d, perMeal, targets.cat);
        return Object.assign({}, d, { err: s.err, match: s.match });
      }).sort(function (a, b) { return a.err - b.err; });

      // Plan semanal: weekDays días × meals platos/día, repartidos para que
      // los días queden equilibrados en calorías.
      var plan = buildWeekPlan(ranked, weekDays, meals);
      var slots = [];
      plan.forEach(function (day) {
        day.items.forEach(function (d) { slots.push(d); });
      });

      // Nº de veces que cada plato aparece en el plan, para marcar repetidos.
      var planCounts = {};
      slots.forEach(function (d) { planCounts[d.id] = (planCounts[d.id] || 0) + 1; });

      var html = renderTargets(targets, T);
      if (!slots.length) {
        html += '<p class="macro-calc__empty">' + escapeHtml(T.noMatches) + '</p>';
      } else {
        var addableCount = slots.filter(function (d) { return d.vid; }).length;
        var addAllBtn = addableCount > 1
          ? '<button type="button" class="button macro-calc__add-all" data-add-all>' +
              escapeHtml(T.addAll.replace('{n}', addableCount)) +
            '</button>'
          : '';
        html += '<div class="macro-calc__results-head">' +
                  '<h3 class="macro-calc__results-title">' + escapeHtml(T.recommended) + '</h3>' +
                  addAllBtn +
                '</div>' +
                '<div class="macro-calc__week">' +
                plan.map(function (day, i) {
                  if (!day.items.length) return '';
                  // span = cabecera + platos/día, para que la celda ocupe las
                  // mismas filas compartidas (subgrid) que el resto de días.
                  return '<section class="macro-calc__day" style="grid-row: span ' + (meals + 1) + '">' +
                    '<div class="macro-calc__day-head">' +
                      '<h4 class="macro-calc__day-name">' + escapeHtml(T.days[i % 7]) + '</h4>' +
                    '</div>' +
                    '<div class="macro-calc__cards">' +
                      day.items.map(function (d) {
                        return renderCard(d, targets, T, showPrice, planCounts[d.id]);
                      }).join('') +
                    '</div>' +
                  '</section>';
                }).join('') +
                '</div>' +
                // Botón repetido al final: tras 10-15 tarjetas, el de arriba
                // queda lejos. El listener delegado sirve para ambos.
                (addAllBtn ? '<div class="macro-calc__results-foot">' + addAllBtn + '</div>' : '');
      }

      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      markCart(MARK_USED);

      // Anuncio corto para lectores de pantalla (el contenedor de resultados
      // no lleva aria-live: verbalizaría las ~15 tarjetas enteras).
      if (statusEl) {
        var daysUsed = plan.filter(function (day) { return day.items.length; }).length;
        statusEl.textContent = slots.length
          ? T.planReady.replace('{n}', slots.length).replace('{d}', daysUsed)
          : T.noMatches;
      }
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      resultsEl.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });

    form.addEventListener('reset', function () {
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      errorEl.hidden = true;
      if (statusEl) statusEl.textContent = '';
    });

    resultsEl.addEventListener('click', function (event) {
      var all = event.target.closest('[data-add-all]');
      if (all) {
        // Una línea por variante, sumando cantidades: si el plan repite un
        // plato (semana más larga que el catálogo), va con quantity > 1.
        var counts = {};
        var order = [];
        resultsEl.querySelectorAll('[data-add]').forEach(function (b) {
          var id = parseInt(b.getAttribute('data-add'), 10);
          if (!id) return;
          if (!counts[id]) {
            counts[id] = 0;
            order.push(id);
          }
          counts[id] += 1;
        });
        var items = order.map(function (id) {
          return { id: id, quantity: counts[id] };
        });
        if (!items.length) return;
        runAddAllAction(all, items, T);
        return;
      }

      var btn = event.target.closest('[data-add]');
      if (!btn) return;
      runCartAction(btn, [{ id: parseInt(btn.getAttribute('data-add'), 10), quantity: 1 }], {
        loading: T.adding,
        done: T.added,
        error: T.errAdd
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-macro-calc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas recarga secciones sin recargar la página.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-macro-calc]').forEach(init);
  });
})();
